import API from "./API";

const CustomerTypeSPService = {
  async getParticularCustomerTypeSP(CustomerTypeSP_id: number) {
    const response = await API().get(
      "Customer/GetCustomerTypeByCustomerId/" + CustomerTypeSP_id,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data[0];
  },
};
export default CustomerTypeSPService;
